<template>
  <tr class="is-size-6" :id='id'>
    <td><span class="icon"><i class="fal fa-file-pdf"></i></span></td>
    <td><a target="_blank" :href="d.path" :download="d.filename">{{d.filename}}</a></td>
    <td class="has-text-right actions">
      <div class="dropdown is-hoverable is-right">
        <div class="dropdown-trigger">
          <button class="button is-circle is-small" @click="selectDocument"
                :class="[{'is-white':!isChecked, 'is-success has-text-white':isChecked}]">
            <i class="fas fa-check"></i>
          </button>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'DocumentsListRow',
    data () {
      return {
        isChecked: false
      }
    },
    props: {
      id: {
        type: String
      },
      source: {
        type: Object
      },
      emailSent: {
        type: Boolean
      }
    },
    watch: {
      emailSent (to, from) {
        if (to === true) {
          this.isChecked = false
        }
      }
    },
    computed: {
      d () {
        return this.source
      }
    },
    methods: {
      selectDocument () {
        this.isChecked = !this.isChecked
        let file = {
          path: this.source.path,
          filename: this.source.filename
        }
        this.$emit('selectedItem', {id: this.id, file})
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/program/Tabs/DocumentsListRow.vue